module.exports = "/virtual-football-league/img/amblems/right/logos/Broomwich.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Broomwich.png
// module id = 2164
// module chunks = 4